import { BRAND } from "@shared/brand";

export const reports = {
  en: {
    payrollRegisterTitle: "Payroll register",
    payrollRegisterDescription: "Every payroll run for a month, one row per employee.",
    gosiTitle: "GOSI contributions",
    gosiDescription: "The monthly contribution schedule, for filing and reconciliation.",
    attendanceTitle: "Attendance summary",
    attendanceDescription: "Days by status, hours worked and approved overtime, per employee.",
    leaveTitle: "Leave balances",
    leaveDescription: "Entitlement, accrued, consumed and remaining, per employee.",
    contractExpiryTitle: "Contract expiry",
    contractExpiryDescription: "Fixed-term contracts ending within the chosen period.",
    employeeMasterTitle: "Employee master",
    employeeMasterDescription: "The full personnel register, including contract terms.",

    allowances: "Allowances",
    gosiEmployee: "GOSI (employee)",
    otherDeductions: "Other deductions",
    contributoryBase: "Contributory base",
    employeeRate: "Rate",
    employeeShare: "Employee share",
    employerShare: "Employer share",
    totalContribution: "Total contribution",
    holidays: "Holidays",
    missingCheckOut: "No check-out",
    workedHours: "Hours worked",
    entitlement: "Entitlement",
    daysRemaining: "Days remaining",
    fullNameAr: "Name (Arabic)",
    dateOfBirth: "Date of birth",

    searchPlaceholder: "Search this report",
    printOrPdf: "Print / PDF",
    exportExcel: "Export to Excel",
    noRows: "No records match these filters.",
    noneAvailable: "Your role does not give you access to any report.",
    rowCount: "{count} rows",
    allBranches: "All branches",
    expiringWithin: "Expiring within",
    days: "{count} days",
    year: "Year",
    from: "From",
    to: "To",
    printedFooter: `${BRAND.en} · printed {date}`,
  },
  ar: {
    payrollRegisterTitle: "سجل الرواتب",
    payrollRegisterDescription: "جميع مسيّرات الرواتب لشهر واحد، سطر لكل موظف.",
    gosiTitle: "اشتراكات التأمينات الاجتماعية",
    gosiDescription: "جدول الاشتراكات الشهري، للرفع والمطابقة.",
    attendanceTitle: "ملخص الحضور",
    attendanceDescription: "الأيام حسب الحالة وساعات العمل والعمل الإضافي المعتمد لكل موظف.",
    leaveTitle: "أرصدة الإجازات",
    leaveDescription: "الاستحقاق والمكتسب والمستهلك والمتبقي لكل موظف.",
    contractExpiryTitle: "العقود المنتهية",
    contractExpiryDescription: "العقود محددة المدة التي تنتهي خلال الفترة المختارة.",
    employeeMasterTitle: "سجل الموظفين",
    employeeMasterDescription: "السجل الكامل للموظفين، شاملاً شروط العقد.",

    allowances: "البدلات",
    gosiEmployee: "التأمينات (حصة الموظف)",
    otherDeductions: "استقطاعات أخرى",
    contributoryBase: "الأجر الخاضع للاشتراك",
    employeeRate: "النسبة",
    employeeShare: "حصة الموظف",
    employerShare: "حصة المنشأة",
    totalContribution: "إجمالي الاشتراك",
    holidays: "العطل",
    missingCheckOut: "بدون انصراف",
    workedHours: "ساعات العمل",
    entitlement: "الاستحقاق",
    daysRemaining: "الأيام المتبقية",
    fullNameAr: "الاسم بالعربية",
    dateOfBirth: "تاريخ الميلاد",

    searchPlaceholder: "ابحث في هذا التقرير",
    printOrPdf: "طباعة / PDF",
    exportExcel: "تصدير إلى Excel",
    noRows: "لا توجد سجلات مطابقة لهذه الخيارات.",
    noneAvailable: "صلاحياتك لا تتيح لك أي تقرير.",
    rowCount: "{count} سطر",
    allBranches: "جميع الفروع",
    expiringWithin: "تنتهي خلال",
    days: "{count} يوم",
    year: "السنة",
    from: "من",
    to: "إلى",
    printedFooter: `${BRAND.ar} · طُبع في {date}`,
  },
} as const;
